exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".BuilderCard-module__wrapper___3oRpV .BuilderCard-module__text___1oQyt{margin-bottom:.75rem;display:grid;grid-template-columns:auto 1fr;gap:.25rem;align-items:center}.BuilderCard-module__wrapper___3oRpV .BuilderCard-module__text___1oQyt p{font-size:18px;color:#b4bac3;font-weight:700}.BuilderCard-module__wrapper___3oRpV .BuilderCard-module__text___1oQyt svg{color:#0827e9}.BuilderCard-module__wrapper___3oRpV .BuilderCard-module__card___3ZQ9M{background-color:#fff;border-radius:17px;min-height:100px;box-shadow:0 0 10px rgba(0,0,0,.05);padding:1.5rem}", ""]);

// exports
exports.locals = {
	"wrapper": "BuilderCard-module__wrapper___3oRpV",
	"text": "BuilderCard-module__text___1oQyt",
	"card": "BuilderCard-module__card___3ZQ9M"
};